import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      const brand = matched['input'].replace("./", "").replace("/en.json", "").replace("/fr.json", "");
      const localeKey = brand + "-" + locale;
      messages[localeKey] = locales(key)
    }
  })
  return messages
}

const numberFormats = {
  'en': {
    currency: {
      style: 'currency', currency: 'USD'
    },
    percent: {
      style: 'percent'
    }
  },
  'fr': { 
    currency: {
      style: 'currency', currency: 'EUR'
    },
    percent: {
      style: 'percent'
    }
  }
}

const dateTimeFormats = {
  'en': {
     short: {
       year: 'numeric',
       month: 'short',
       day: 'numeric'
     },
     long: { 
       year: 'numeric', 
       month: 'short',
       day: 'numeric',
       weekday: 'short',
       hour: 'numeric',
       minute: 'numeric',
       hour12: true
     }
   },
 'fr': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'swiss-en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'swiss-en',
  numbers: numberFormats,
  messages: loadLocaleMessages(),  // pull content translations from json files in /locales folder
  dateTimeFormats, // set date and time formats to specific formats above
  numberFormats // set number formats to specific formats above  
})
